export const QUERY_INVITATION_BY_TOKEN = "QUERY_INVITATION_BY_TOKEN";
